import {Injectable} from "@angular/core";
import {LocalStorageService} from "../Storage/LocalStorageService";
import {Subject} from 'rxjs/Subject';
var moment = require('moment-timezone');

@Injectable()
export class MessagesService {
    public msgs: NPS.Common.IMessage[] = [];
    public notificationsStream = new Subject<NPS.Common.IMessage>();
    private notificationsStorageKey: string = "notifications";
    private timeZoneIdentifier: string = "Europe/Oslo";

    constructor(private localStorageService: LocalStorageService) {
    }

    add(message: string, details: string = "", success: boolean = true) {
        let notificationTime : string = (<any>moment()).tz(this.timeZoneIdentifier).format("HH:mm"); 
        let newNotification : NPS.Common.IMessage = {
                                                        severity: success ? "info" : "error",
                                                        summary: message, detail: details,
                                                        time: notificationTime
                                                    };
        this.msgs.push(newNotification);
        this.setNewNotification(newNotification);
        this.notificationsStream.next(newNotification);
    }

    hide() {
        this.msgs = [];
    }

    getNotifications(): NPS.Common.IMessage[]{
        let notificationFromLocalStorage = this.localStorageService.get<NPS.Common.IMessage[]>(this.notificationsStorageKey);
        return notificationFromLocalStorage
                        ? notificationFromLocalStorage
                        : [];
    }

    setNewNotification(notification: NPS.Common.IMessage): void{
       let oldNotifications : NPS.Common.IMessage[] = this.getNotifications();
       oldNotifications.push(notification);
       this.localStorageService.set<NPS.Common.IMessage[]>(this.notificationsStorageKey, oldNotifications);
    }

}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Messages/MessagesService.ts